// pack-manifest-store.ts
//
// v3: Pack tải qua tarball Supabase (không còn git submodule) → metadata version
// không đọc từ git tag được nữa. Thay bằng file manifest ghi sau khi extract.
//
// Manifest sống tại `.claude/pack/.avatar-pack-manifest.json`:
//   { version, downloadedObject, sha256?, extractedAt }
//
// Đọc version ưu tiên manifest; fallback `.pack-version` (file kèm trong tarball
// do script release ghi) nếu manifest thiếu (vd pack cài tay).
import { join } from "node:path";
import { pathExists, readJson, readText, writeJsonAtomic } from "./filesystem-helpers.js";

export const PACK_MANIFEST_FILENAME = ".avatar-pack-manifest.json";
export const PACK_VERSION_FILENAME = ".pack-version";

export interface PackManifest {
  version: string; // vd "v0.2.0"
  downloadedObject: string; // vd "pack-v0.2.0.tar.gz"
  sha256?: string; // hash tarball đã tải (nếu Supabase cung cấp)
  extractedAt: string; // ISO timestamp
}

function manifestPath(packDir: string): string {
  return join(packDir, PACK_MANIFEST_FILENAME);
}

export async function writePackManifest(packDir: string, data: PackManifest): Promise<void> {
  await writeJsonAtomic(manifestPath(packDir), data);
}

export async function readPackManifest(packDir: string): Promise<PackManifest | null> {
  const p = manifestPath(packDir);
  if (!(await pathExists(p))) return null;
  try {
    return await readJson<PackManifest>(p);
  } catch {
    return null;
  }
}

// Đọc version pack đang cài. Ưu tiên manifest → fallback .pack-version → null.
export async function readPackVersionFromFile(packDir: string): Promise<string | null> {
  const manifest = await readPackManifest(packDir);
  if (manifest?.version) return manifest.version;

  const versionFile = join(packDir, PACK_VERSION_FILENAME);
  if (await pathExists(versionFile)) {
    const v = (await readText(versionFile)).trim();
    if (v) return v;
  }
  return null;
}
